module.exports = __webpack_public_path__ + "img/sleep.e4b80cec.svg";